<template>
  <div class="qa-list">
    <div
      v-for="(q, idx) in items"
      :key="idx"
      class="qa-card"
      @click="lbBtn(q)"
    >
      <div class="qa-card-header" style="margin-bottom: 10px;">
        <img v-if="lxval!=='2'" class="avatar" :src="q.avatar" alt="头像">

        <div class="qa-head">
          <div class="qa-row">
            <span v-if="lxval!=='2'" class="name" :title="q.name">{{ q.name }}</span>
            <span class="status" :class="{ unsolved: q.type === 1, solved: q.type === 2 }">{{ q.type === 1 ? '未解决' : '已解决' }}</span>
            <span class="category">{{ q.category || '工业建筑' }}</span>
          </div>
        </div>

        <div class="qa-card-right">回答人数：{{ q.answerCount }}</div>
      </div>

      <!-- 标题 -->
      <div v-if="q.title" class="qa-title">{{ q.title }}</div>

      <!-- 内容 -->
      <div v-if="q.content" class="qa-content">{{ q.content }}</div>

      <div v-if="q.image" class="qa-card-image">
        <img :src="q.image" alt="封面">
      </div>
      <div class="qa-card-footer">
        <span class="bounty">悬赏金额：¥ {{ q.bounty }}</span>
        <div v-if="lxval == '1'" class="right-actions">
          <span class="collect-btn" :class="{ collected: q.is_collected }" @click.stop="$emit('collect', q)">
            <img class="collect-icon" :src="q.is_collected ? require('@/assets/image/scy.png') : require('@/assets/image/scn.png')" alt="收藏">
            {{ q.is_collected ? '已收藏' : '收藏' }}
          </span>
          <span class="time">{{ q.time }}</span>
          <span v-if="showReply" class="reply" @click.stop="$emit('reply', q)">
            <img class="reply-icon" :src="require('@/assets/image/al/huifu.png')" alt="回复">
            回复
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QAList',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    lxval: { // 1: 问题列表, 2: 我的发布, 3: 我的问答
      type: String,
      default: '1'
    },
    showReply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      huifuIcon: require('@/assets/image/al/huifu.png')
    }
  },
  methods: {
    lbBtn(q) {
      const obj = q
      obj.lxval = this.lxval
      this.$emit('select', obj)
    }
  }
}
</script>

<style scoped>
.qa-card{
  background: #fff;
  border-radius: 10px;
  padding: 12px 14px 10px;
  box-shadow: 0 2px 8px rgba(31,35,41,0.06);
  margin-bottom: 16px;
  cursor: pointer;
}
.qa-card-header{
  display: flex;
  align-items: center;
}
.reply-icon{
  width: 18px;
  height: 18px;
  margin-top: 2px;
  margin-right: 8px;
}
.qa-head{ flex: 1; }
.qa-row{ display: flex; align-items: center; gap: 10px; }
.name{ color: #606266; font-weight: 600; font-size: 14px; }
.status{ font-size: 12px; padding: 2px 8px; border-radius: 12px; background: #EFF2F5; color: #8A8F99; }
.status.solved{ background: #E6F4FF; color: #1E80FF; }
.status.unsolved{ background: #EFF2F5; color: #8A8F99; }
.category{ font-size: 12px; color: #F29E38; }
.qa-card-right{ color: #1E80FF; font-size: 12px; }
.avatar{
	width: 40px;
	height: 40px;
	border-radius: 50%;
	margin-right: 8px;
}
.qa-title{
  font-weight: 600;
  color: #333;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qa-content{
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.qa-meta{
  margin-top: 6px;
  color: #8A8F99;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.qa-meta .dot{
  width: 3px; height: 3px; background: #CBD0D7; border-radius: 50%; display: inline-block;
}
.qa-card-image {
  margin: 10px 0;
  border-radius: 8px;
  overflow: hidden;
}
.qa-card-image img{
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}
.qa-card-footer{ display: flex; justify-content: space-between; align-items: center; }
.qa-card-footer .bounty{ color: #FF4800; font-size: 18px; }
.right-actions{ display: flex; align-items: center; gap: 16px; color: #909399; font-size: 12px; }
.right-actions .collect-btn{ display: flex; align-items: center; gap: 4px; color: #909399; cursor: pointer; transition: color 0.3s; }
.right-actions .collect-btn:hover{ color: #1E80FF; }
.right-actions .collect-btn.collected{ color: #FF4800; }
.right-actions .collect-icon{ width: 14px; height: 14px; }
.right-actions .reply{ display: flex; align-items: center; gap: 6px; color: #1E80FF; cursor: pointer; }
.right-actions .reply .reply-icon{ width: 14px; height: 14px; margin: 0; }
</style>

